import React from "react";
import Section from "@/theme/Section";
import { useContent } from "@/lib/content";

const Clients = () => {
  const { sections } = useContent();
  const s = sections.clients || {};
  if (!s.enabled) return null;
  const items = (s.items || []).filter((i) => i.enabled);
  if (items.length === 0) return null;
  return (
    <Section
      id="clients"
      testid="clients-section"
      eyebrow="Our Clients"
      eyebrowColor="#2ad6ff"
      title='Trusted by <span style="color:#2ad6ff">great</span> studios'
    >
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6">
        {items.map((c, i) => (
          <div
            key={c.id}
            data-testid={`client-${i}`}
            className="aspect-square flex items-center justify-center p-5 transition-all hover:-translate-y-1"
            style={{
              background: "rgba(13,13,13,0.7)",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: "20px",
              backdropFilter: "blur(14px)",
            }}
            title={c.name}
          >
            {c.logo ? (
              <img
                src={c.logo}
                alt={c.name}
                className="max-w-full max-h-full object-contain rounded-2xl transition-transform duration-300 hover:scale-110"
              />
            ) : (
              <span className="font-black text-sm text-white/70 uppercase tracking-tight text-center">
                {c.name}
              </span>
            )}
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Clients;
